import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Input,
} from '@angular/core';
import { MMRContactHours } from '../../../types/manage-my-repair-types';
@Component({
  selector: 'claims-dg-home-myaccount-contact-hours',
  templateUrl: './contact-hours.component.html',
  styleUrls: ['./contact-hours.component.scss'],
})
export class ContactHoursComponent implements AfterViewInit {
  @Input() contactHours: MMRContactHours;

  @Input() showOpeningHoursTitle = true;

  @Input() accordionStyle = false;

  @Input() openByDefault = false;

  isOpen = false;

  order = [
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
    'sunday',
  ];

  constructor(private cdr: ChangeDetectorRef) {}
  ngAfterViewInit(): void {
    if (this.openByDefault) {
      this.isOpen = true;
      this.cdr.detectChanges();
    }
  }
}
